import {NgStyle} from '@angular/common';
import {ChangeDetectionStrategy, Component, Input, input} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {DcColorType} from '@shared-types';

@Component({
	selector: 'dc-badge',
	imports: [TranslateModule, NgStyle],
	templateUrl: './badge.component.html',
	styleUrls: ['./badge.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeComponent {
	readonly dcColor = input<DcColorType>(DcColorType.Primary);
	readonly customColor = input<{
		color: string;
		lighten: string;
	}>(null);

	/* -------------------------- Optional Properties: -------------------------- */
	readonly enableDot = input(false);
	readonly border = input(false);

	/* ---------------------------- Text Properties: ---------------------------- */
	readonly text = input<string>(undefined);
	readonly bold = input(false);
	// TODO: Skipped for migration because:
	//  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
	//  and migrating would break narrowing currently.
	@Input() textColor: string = null;

	constructor() {}

	protected get badgeColors(): {color: string; lighten: string} {
		const customColor = this.customColor();
		if (customColor) return customColor;
		const lighten = `var(${this.dcColor() + '-lighten'})`;
		return {
			color: `var(${this.dcColor()})`,
			lighten: lighten,
		};
	}
}
